module.exports = __webpack_public_path__ + "static/media/AWSPartnerNetwork.160bcddc.png";